import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { Box, Checkbox, IconButton, Typography } from "@mui/material"
import { Types } from "../../../../../../../utils/enums"
import { loogbookServiceFetch } from "../../../../../../../utils/constants/callService"
import { returnQuery } from "../../../../../../../utils/methods/returnQuery"
import { FilterBody } from "../../../../../../../hooks/filter/typing"
import { formatInputFilter } from "../constants"
import { formatDailyCutsResponse } from "../../../../../../../service/logbook/format/dailyCuts"
import { icons } from "../../../../../../../utils/icons"
import { useStyles } from "../styles"
import { UserService } from "../../../../../../../service"
import { httpFetch } from "../../../../../../../utils/crud"
import { getLocalStorage } from "../../../../../../../utils/crud/crypt"

const useBody = (createFilter: FilterBody, indexFilter: FilterBody) => {

  const { t } = useTranslation()
  const styles = useStyles()
  const [totalPages, setTotalPages] = useState(0)
  const [step, setStep] = useState(0)
  const [usersSelected, setUsersSelected] = useState<number[]>([])
  const [cutsSelected, setCutsSelected] = useState<number[]>([])
  const [cutsNoSelected, setCutsNoSelected] = useState<number[]>([])
  const [all, setAll] = useState(false)
  const [check, setCheck] = useState(false)
  const [totalCuts, setTotalCuts] = useState(0)

  const [modalLoad, setModalLoad] = useState<{ open: boolean; tmpUsuers?: Record<string, string | boolean>[] }>({ open: false })
  const [loadings, setLoadings] = useState({ search: false, load: false, table: false, submit: false, main: false })
  const [snackbar, setSnackbar] = useState<{ open: boolean; type: Types; message: string }>({
    open: false,
    message: '',
    type: Types.SUCCESS,
  })

  const [row, setRow] = useState<{
    id: number,
    title: String,
    dateGeneration: string,
    reportUrl: string
  }[]>([])

  const column = [
    {
      id: 'check',
      label: t('department.form.tabs.notified'),
      headerCell: {
        width:'50px'
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="check"
              checked={check}
              onChange={(_, check) => {
                setCheck(check)
                if (!check) {
                  setAll(check)
                } else {
                  setAll(check)
                }
                setCutsSelected([])
                setCutsNoSelected([])
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="checkByUser"
              checked={all ? !cutsNoSelected.includes(params.row.id) : cutsSelected.includes(params.row.id)}
              onChange={(_, check) => {
                if (all) {
                  hanbdleNoChecksByUser({ id: params.row.id, check })
                } else {
                  hanbdleChecksByUser({ id: params.row.id, check })
                }
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    {
      id: 'title',
      label: t('general.tags.name')
    },
    {
      id: 'dateGeneration',
      label: t('loogbook.columns.dateOfGeneration')
    },
    {
      id: 'actions',
      label: t('general.seeReport2'),
      renderCell: ({ row }: any) => {
        return (
          <IconButton sx={styles.button} onClick={() => { window.open(row.reportUrl, "_blank") }}>{icons('paper')}</IconButton>
        );
      },
    },
  ]

  const columnUsers = [
    {
      id: 'name',
      label: t('general.tags.name'),
    },
    {
      id: 'role',
      label: t('general.tags.role'),
    },
    {
      id: 'area',
      label: t('general.tags.area'),
    },
    {
      id: 'department',
      label: t('general.tags.department'),
    },
    {
      id: 'division',
      label: t('general.tags.division'),
    },

  ]


  const searchUsers = async () => {
    try {
      setLoadings(prev => ({ ...prev, search: true }))
      //const response = await userServiceFetch.filterUsers({ query: `status_ids=1&${returnQuery(createFilter.query, {})}` })

      const state = getLocalStorage()
      const companyId = state?.company?.id
      const companyQueary = companyId ? `company_id=${companyId}&`: ''
      const response = await UserService(httpFetch).userDetail({ query: `${companyQueary}${ returnQuery(createFilter.query, {}) }` })

      let allUsers: Record<string, string | boolean>[] = response?.items?.map(item => ({
        id: item.id.toString(),
        name: `${item.firstName} ${item.lastName}`,
        role: item.role ? String(item.role) : 'N/A',
        area: item.area ? String(item.area) : 'N/A',
        department: item.department ? String(item.department) : 'N/A',
        division: item.division ? String(item.division) : 'N/A'
      })) ?? []
      if (!!allUsers?.length) {
        setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: allUsers }))
      } else {
        setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
        setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
      }
    } catch (e) {
      setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
      setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
    }
    finally {
      setLoadings(prev => ({ ...prev, search: false }))
    }
  }

  const handleSubmit = async () =>{

    setLoadings(prev => ({ ...prev, submit: true }))

    const usersSelectedNumber = usersSelected.map(Number);

    const body = {
      all: all,
      userIds: usersSelectedNumber,
      reportIds: cutsSelected, 
      reportsNotSend: cutsNoSelected
    }

    const response = await loogbookServiceFetch.resendReports({ body })

    if(!response.errors){
      setSnackbar(prev => ({ ...prev, open: true, message: t("loogbook.snackbar.resendReport.success"), type: Types.SUCCESS }))
      setStep(0)
      setAll(false)
      setCutsSelected([])
      setCutsNoSelected([])
      setUsersSelected([])
      setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
      createFilter.cleanFilter()
      indexFilter.cleanFilter()
    } else {
      setSnackbar(prev => ({ ...prev, open: true, message: t("loogbook.snackbar.resendReport.error"), type: Types.ERROR }))
    }
    setLoadings(prev => ({ ...prev, submit: false }))

  }

  const hanbdleChecksByUser = ({ id, check }: { id: number; check: boolean }) => {

    if (check) {
      setCutsSelected((prevCuts) => {
        return prevCuts.includes(id) ? prevCuts : [...prevCuts, id];
      });
    } else {
      setCutsSelected((prevCuts) => {
        return prevCuts.filter((cutId) => cutId !== id);
      });
    }


  };

  const hanbdleNoChecksByUser = ({ id, check }: { id: number; check: boolean }) => {

    if (!check) {
      setCheck(false)
      setCutsNoSelected((prevCuts) => {
        return prevCuts.includes(id) ? prevCuts : [...prevCuts, id];
      });
    } else {
      if (cutsNoSelected.length == 1) {
        setCheck(true)
      }
      setCutsNoSelected((prevCuts) => {
        return prevCuts.filter((cutId) => cutId !== id);
      });
    }
    /* setCutsNoSelected((prevCuts) => {
      return prevCuts.includes(id) ? prevCuts : [...prevCuts, id];
    }); */
  };

  const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }

  const searcDailyCuts = async () => {
    setLoadings(prev => ({ ...prev, table: true }))

    const response = await loogbookServiceFetch.getDailyCuts({ query: returnQuery({ ...indexFilter.query, filter: indexFilter.query.filter?.replaceAll('+', '%2B') }, formatInputFilter) })

    const { row, totalPages, totalCuts } = formatDailyCutsResponse({ response })

    setTotalCuts(totalCuts)

    setRow(row)

    setTotalPages(totalPages)

    setLoadings(prev => ({ ...prev, table: false }))

  }

  useEffect(() => {
    searcDailyCuts()
  }, [])

  useEffect(() => {
    searcDailyCuts()
  }, [indexFilter.query.all])



  return {
    column,
    row,
    step,
    setStep,
    columnUsers,
    usersSelected,
    cutsSelected,
    setUsersSelected,
    modalLoad,
    loadings,
    snackbar,
    searchUsers,
    closeSnackbar,
    totalPages,
    all,
    cutsNoSelected,
    totalCuts,
    handleSubmit
  }
}

export { useBody }